/**
 * EntityImageFallback — the Archive's deliberate "no verified image yet"
 * placeholder. Span-based markup so it can legally render inside prose
 * <p> elements (mini cards). Never fakes a portrait, seal or building —
 * it communicates IMAGE NOT YET VERIFIED per entity type.
 */
import React from "react";
import {
  User, Building2, Landmark, Plane, MapPin, Factory, Home, Share2,
  Crosshair, FileText, Car,
} from "lucide-react";

const KIND_META = {
  person: [User, "Person"],
  organization: [Building2, "Organization"],
  government_agency: [Landmark, "Government Agency"],
  company: [Factory, "Corporation"],
  group_or_network: [Share2, "Group / Network"],
  place: [MapPin, "Location"],
  location: [MapPin, "Location"],
  property: [Home, "Property"],
  aircraft: [Plane, "Aircraft"],
  vehicle: [Car, "Vehicle"],
  operation: [Crosshair, "Operation"],
  program: [Crosshair, "Program"],
  event: [FileText, "Event"],
};

export const EntityImageFallback = ({ kind, className = "", iconSize = 16, compact = false }) => {
  const [Icon, label] = KIND_META[(kind || "").toLowerCase()] || [FileText, "Entity"];
  return (
    <span
      className={`relative flex flex-col items-center justify-center gap-1 px-1 text-center overflow-hidden ${className}`}
      style={{ border: "1px solid #2D2A26", background: "#0B0A0D" }}
      data-testid="entity-image-fallback"
      aria-label={`${label} — image not yet verified`}
    >
      <span aria-hidden="true" className="absolute top-1 left-1 w-2 h-2 border-t border-l block"
            style={{ borderColor: "#3A342B" }} />
      <span aria-hidden="true" className="absolute bottom-1 right-1 w-2 h-2 border-b border-r block"
            style={{ borderColor: "#3A342B" }} />
      <Icon size={iconSize} className="text-[#454038]" />
      {!compact && (
        <span className="font-mono text-[7px] uppercase tracking-[0.2em] text-[#5A554C] leading-tight block">
          {label}
        </span>
      )}
      <span className="font-mono text-[6.5px] uppercase tracking-[0.18em] text-[#7B7168] leading-tight block">
        Image not yet verified
      </span>
    </span>
  );
};

export default EntityImageFallback;
